import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";

import { CloseGameSessionPayload } from "./game-session.model";

export const ACTION_PREFIX = "[Game Session]";

export const GAME_SESSION_ACTION_TYPE = {
	setActiveGameSession: `${ACTION_PREFIX} Set active game session`,
	closeGameSession: `${ACTION_PREFIX} Close game session`,
	closeGameSessionSuccess: `${ACTION_PREFIX} Close game session Success`,
	closeGameSessionFail: `${ACTION_PREFIX} Close game session Fail`,
};

@Injectable({
	providedIn: "root",
})
export class GameSessionAction {
	setActiveGameSession(payload: string): ActionWithPayload {
		return {
			type: GAME_SESSION_ACTION_TYPE.setActiveGameSession,
			payload,
		};
	}

	closeGameSession(payload: CloseGameSessionPayload): ActionWithPayload {
		return {
			type: GAME_SESSION_ACTION_TYPE.closeGameSession,
			payload,
		};
	}

	closeGameSessionSuccess(payload: boolean): ActionWithPayload {
		return {
			type: GAME_SESSION_ACTION_TYPE.closeGameSessionSuccess,
			payload,
		};
	}

	closeGameSessionFail(): Action {
		return {
			type: GAME_SESSION_ACTION_TYPE.closeGameSessionFail,
		};
	}
}
